export const GET_USERDATA = 'get_userdata';
export const GET_NEWS = 'get_news';
export const GET_DEADLINE = 'get_deadline';

export const GET_GROUPS = 'get_groups';

export const PROFILE_CHANGE = 'profile_change';
export const GROUP_CHANGE = 'group_change';

export const WRITE_NEWS = 'write_news';
export const CLEAR_WRITE = 'clear_write';
export const ADD_NEWS = 'add_news';
export const DELETE_NEWS = 'delete_news';
export const EDIT_NEWS = 'edit_news';
export const SELECT_NEWS = 'select_news';

export const GET_MENTORS = 'get_mentors';

export const GET_IMAGES = 'get_images';

export const GET_TASKS = 'get_homeworks';
export const ADD_TASK = 'add_task';
export const DELETE_TASK = 'delete_task';
export const EDIT_TASK = 'edit_task';
export const WRITE_TASK = 'write_task';
export const SELECT_TASK = 'select_task';
export const WRITE_SOLUTION = 'write_solution';
export const WRITE_SOLUTION_FILE = 'write_solution_file';
export const WRITE_TASK_DEADLINE = 'write_task_deadline';
export const GET_SOLUTIONS = 'get_solutions';
export const ADD_SOLUTION = 'add_solution';
export const ADD_DOCUMENT = 'add_document';
export const GET_DOCUMENTS = 'get_documents';
export const CORRECT_SOLUTION = 'correct_solution';
export const SELECT_SOLUTION = 'select_solution';
export const CHECK = 'check';
export const SETCHECKTRUE = 'setchecktrue';

export const GET_EVENTS = 'get_events';
export const GET_EVENT_BY_ID = 'get_event_by_id';

export const GET_TRAINEES = 'get_trainees';
export const VISITOR_CHANGE = 'visitor_change';
export const ABSENT_CHANGE = 'absent_change';
export const CHANGE_NO = 'change_no';

export const GET_NOTES_BY_EVENT = 'get_notes_by_event';
export const WRITE_EVENT = 'write_event';
export const ADD_EVENT = 'add_event';
export const DELETE_EVENT = 'delete_event';

export const WRITE_NOTE = 'write_note';
export const CLEAR_NOTE = 'clear_note';
export const ADD_EVENT_NOTE = 'add_note';

export const GET_PROFILES = 'get_profiles';
export const SET_STATUS = 'set_status';
export const GET_SELECTED_PROFILE = 'get_selected_profile';
